import { render, staticRenderFns } from "./infoEdit.vue?vue&type=template&id=0d3b2022&scoped=true"
import script from "./infoEdit.vue?vue&type=script&lang=js"
export * from "./infoEdit.vue?vue&type=script&lang=js"
import style0 from "./infoEdit.vue?vue&type=style&index=0&id=0d3b2022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b2022",
  null
  
)

export default component.exports